export default __webpack_public_path__ + "static/media/reddit.5c63bec9.png";